export const voiceMsgTypes = {
  SET_VOICE_RECORDING: "SET_VOICE_RECORDING",
  SET_RECORDING_AUDIO: "SET_RECORDING_AUDIO",
  SET_AUDIO_STREAM: "SET_AUDIO_STREAM",
  RESET_VOICE_RECORDING_DATA: "RESET_VOICE_RECORDING_DATA",
};
